export const getAvailableRoles = (member) => {
  if (member.is_admin) {
    return ["assistant", "doctor"];
  }
  if (member.role === "assistant") {
    return ["admin", "doctor"];
  }
  if (member.role === "doctor") {
    return ["admin", "assistant"];
  }
  return [];
};
